import React from 'react'
import { Checkbox } from 'antd';
import listLineShipBox from '../../../helpers/listLineShipBox'

function BatchShipHead(props) {
    const { userRoles, selectAll, status, boxCarrier } = props
    const showShippingFee = !!userRoles.length && (userRoles.includes('fac_admin') || userRoles.includes('fac_ffm'))

    const _handleChangeChecked = (e) => {
        const checked = e.target.checked
        const {onCheckALl} = props

        if (typeof onCheckALl === 'function') {
            onCheckALl(checked)
        }
    }

    return (
        <thead
            className="BatchShipHead"
            style={{ background: '#e9ecef' }}
        >
            <tr>
                {
                    status === 'confirmed' && listLineShipBox.includes(boxCarrier) && 
                    <th className='SelectBox'>
                        {/* <input type='checkbox' checked={selectAll} onChange={_handleChangeChecked}/> */}
                        <Checkbox checked={selectAll} onChange={_handleChangeChecked}/>
                    </th>
                }
                <th className="Id">ID</th>
                <th className="Create_at">Ngày tạo</th>
                <th className="Update_at">Ngày cập nhật</th>
                <th className="Status">Trạng thái</th>
                <th className="Record">Box Carrier</th>
                <th className="Total_box">Số lượng thùng</th>
                <th className="Total_box_success">Số thùng tạo thành công</th>
                <th className="Tracking_number">Tracking number</th>
                <th className="Carrier">Carrier</th>
                <th className="Shipng_status">Trạng thái ship</th>
                {showShippingFee &&
                    <th className="Price">Phí ship lô</th>
                }
                <th className="Action">Action</th>
            </tr>
        </thead>
    )
}

export default BatchShipHead